import React from 'react';
import RetailCategoryPrices from './RetailCategoryPrices';

export default function DistributorOrderPricing({
  dollarOrderingUnavailable,
  enabled,
  pricingAvailable,
  piecePricing,
  cashEnabled,
  pricing,
  pricingError,
  locale,
  t,
}) {
  return (
    <>
      {dollarOrderingUnavailable ? (
        <p role="alert" className="me-do-feedback me-do-feedback-error">
          {t('Dollar-bank ordering is unavailable. Contact MedEffects before placing this order.')}
        </p>
      ) : (
        !enabled && <p className="me-do-feedback">{t('Ordering is disabled for this clinic.')}</p>
      )}
      {pricingAvailable && piecePricing ? (
        <p className="me-do-feedback">
          {t('Customer retail pricing per piece')}:{' '}
          <RetailCategoryPrices settings={pricing} t={t} />
        </p>
      ) : pricingAvailable ? (
        <p className="me-do-feedback">
          {t(cashEnabled ? 'Customer rate per unit' : 'Rate per unit')}:{' '}
          {pricing.ratePerUnit.toLocaleString(locale, {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          })}{' '}
          USD
        </p>
      ) : (
        <p role="alert" className="me-do-feedback me-do-feedback-error">
          {t(pricingError)}
        </p>
      )}
    </>
  );
}

export function DistributorOrderHeader({ heldOrder, clinicMode, cashEnabled, piecePricing, t }) {
  return (
    <header className="me-do-header">
      <span className="me-do-header-icon material-symbols-outlined" aria-hidden="true">
        add_shopping_cart
      </span>
      <div>
        <h2>
          {t(
            heldOrder ? 'Review order changes' : clinicMode ? 'New order' : 'New distributor order'
          )}
        </h2>
        <p>
          {t(
            clinicMode
              ? 'Review your products and delivery details before submitting.'
              : cashEnabled || piecePricing
                ? 'Products and shipping are deducted from your cash bank.'
                : 'Orders use available product-family units from your bank.'
          )}
        </p>
      </div>
    </header>
  );
}
